import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})

export class CartComponent implements OnInit {

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetIndustryProductsStocksFiltered();
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();

  ngOnInit(): void {
    this.InitializeFilter();
    this.parent.InitializeCart();
  }

  Filter: {[k: string]: any} = {};
  CurrentShippingAddress:any;

InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.Brand = {};
  this.Filter.Brand = null;

  this.Filter.ProductBoxStatus = {};
  this.Filter.ProductBoxStatus = null;

  this.Filter.ProductConditionStatus = {};
  this.Filter.ProductConditionStatus = null;

  this.Filter.ProductManufacturingStatus = {};
  this.Filter.ProductManufacturingStatus = null;

  this.Filter.ProductVersionStatus = {};
  this.Filter.ProductVersionStatus = null;

  this.Filter.Creator = {};
  this.Filter.Creator = null;

  this.Filter.Updater = {};
  this.Filter.Updater = null;

  this.Filter.CombineProductsByID = true;
}

loadingProducts:boolean;
SearchedProducts:any[];

InitializeSearchProduct(){
  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.GetIndustryProductsStocksFiltered();
  }
}

GetIndustryProductsStocksFiltered(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["StockProducts"];
    }

    this.loadingProducts = false;
   });
}

AllSelected:boolean;

SelectAll(){
  this.parent.Cart.Items.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.parent.Cart.Items.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

ShowStockProducts:boolean = false;
ShowBillingInformation:boolean = false;
ShowShippingInformation:boolean = false;

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.parent.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });

  this.parent.UpdateCart();
}

SelectShippingAddressAddress(a:any){
  if (this.parent.Cart.Partner.ShippingAddresses) {
    this.parent.Cart.Partner.ShippingAddresses.forEach((address: any) => {
      
      if(address.ID != a.ID){
        address.IsSelected = false;
      }
      else{
        address.IsSelected = true;
      }

      this.AddUpdateShippingAddress(address);

    });

    this.parent.UpdateCart();
  }


}

AddUpdateShippingAddress(a:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingAddress:a,
    PartnerID:this.parent.Cart.Partner.ID,
  };

  this.parent.loading = true;

  this.service.AddUpdateShippingAddress(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

    }

    this.parent.loading = false;
   });
}

SuccessfullyAddedOrder:boolean = false;
OfferRequest: {[k: string]: any} = {};

AddNewOffer(){
 if(this.parent.loading != true){

  this.OfferRequest.UserUploader = this.parent.User;
  this.OfferRequest.AgentManager = this.parent.B2BAgent;
  this.OfferRequest.Company = this.parent.Company;
  this.OfferRequest.Cart = this.parent.Cart;
  this.OfferRequest.Type = this.parent.CartMasterData.OrderTypes[4];
  this.OfferRequest.PaymentType = this.parent.Cart.PaymentType;
  this.OfferRequest.DeliveryPreference = this.parent.Cart.DeliveryPreference;
  this.OfferRequest.ShippingAddress = this.CurrentShippingAddress;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    OfferRequest:this.OfferRequest
  };

  this.parent.loading = true;

  this.B2BService.AddNewOfferRequest(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var OfferRequest = response["OfferRequest"];
      localStorage.removeItem("Cart");
      this.GoToRequestOfferConfirmation(OfferRequest.ID);
    }

    this.parent.loading = false;
   });
 }
}

GoToRequestOfferConfirmation(RequestOfferID:any){
  this.router.navigate(['B2B/store/cart/offer/reqest/confirmation'], { queryParams: { RequestOfferID: RequestOfferID } });
}

}
